function fn_part_social () {
    var $fn = $(".part_social");

    $fn.each(function(){
        var $elm = $(this);

        setTimeout(function(){
            $elm.on("click", "[data-list] a", function(e) {
                e.preventDefault();
                if (!$(this).hasClass("mod--active")) {
                    $(this).addClass("mod--active").siblings().removeClass("mod--active");
                }
                $elm.find("[data-slider]").slick('slickGoTo',$(this).index());
            });
            $elm.on("click", "[data-nav]", function(e) {
                e.preventDefault();
                var $this = $(this);

                if ($this.data("nav") == "next") {
                    $elm.find("[data-slider]").slick('slickNext');
                } else {
                    $elm.find("[data-slider]").slick('slickPrev');
                }
            });

            $elm.find("[data-slider]").slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 3000,
                cssEase: 'linear',
                asNavFor: $elm.find("[data-caption]")
            }).on('afterChange', function(){
                $elm.find("[data-item-info] i").text($(this).find(".slick-active").data("slider-info"));
                $(this).find(".slick-active").find("img").addClass("lazyload");
            }).on('beforeChange', function(){
                $(this).find(".slick-active").next().find("img").addClass("lazyload");
            });

            $elm.find("[data-caption]").slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 3000,
                cssEase: 'linear',
                asNavFor: $elm.find("[data-slider]")
            });
        },250);
    });
}